import { useQuery } from 'react-query';
import { ApproversApi } from 'api/timesheets/approvers';
import { GENERAL_API_STALE } from 'config/query-config';
import { APPROVERS_CONFIGURATION_KEY } from './constants';

export const useTimesheetApproversMapping = () => {
  return useQuery(
    APPROVERS_CONFIGURATION_KEY,
    () => {
      return ApproversApi.get();
    },
    {
      staleTime: GENERAL_API_STALE,
    },
  );
};
